function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "film"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 2934"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M15.7709 3H4.56232C3.69948 3 3 3.69243 3 4.54659V15.6423C3 16.4965 3.69948 17.1889 4.56232 17.1889H15.7709C16.6338 17.1889 17.3333 16.4965 17.3333 15.6423V4.54659C17.3333 3.69243 16.6338 3 15.7709 3Z",
  stroke: "#767A8A",
  strokeWidth: 1.28999,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M6.58325 3V17.1889",
  stroke: "#767A8A",
  strokeWidth: 1.28999,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M13.75 3V17.1889",
  stroke: "#767A8A",
  strokeWidth: 1.28999,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M3 10.0944H17.3333",
  stroke: "#767A8A",
  strokeWidth: 1.28999,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M3 6.54718H6.58331",
  stroke: "#767A8A",
  strokeWidth: 1.28999,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M3 13.6416H6.58331",
  stroke: "#767A8A",
  strokeWidth: 1.28999,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M13.75 13.6416H17.3333",
  stroke: "#767A8A",
  strokeWidth: 1.28999,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M13.75 6.54718H17.3333",
  stroke: "#767A8A",
  strokeWidth: 1.28999,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const SvgFilm = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilm, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/film.7a535ba2.svg";
export { ForwardRef as ReactComponent };